<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="12"
        md="12"
        sm="12"
      >
        <h2>{{ title }}</h2>
      </v-col>
    </v-row>
    <v-row v-if="item.is_deleted">
      <v-col>
        <span class="subtitle-1 red--text">※このデータは削除済です。</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
        <v-subheader>顧客情報</v-subheader>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <client-search
          v-if="$attrs.isCreate"
          :has-set="client_haset"
          @setClient="setClient($event)">
        </client-search>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*顧客コード"
          v-model="item.client.cd"
          :readonly="!$attrs.isCreate"
          :error-messages="validation_errors.client.cd"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="業種分類"
          :items=$store.getters.industryCodes
          :readonly="!$attrs.isCreate"
          item-text="label"
          item-value="id"
          v-model="item.client.industrycode"
          :error-messages="validation_errors.client.industrycode"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="検索用カナ"
          :readonly="!$attrs.isCreate"
          v-model="item.client.search_kana"
          :error-messages="validation_errors.client.search_kana"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*会社名または個人名"
          :readonly="!$attrs.isCreate"
          v-model="item.client.name1"
          :error-messages="validation_errors.client.name1"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="部署名"
          :readonly="!$attrs.isCreate"
          v-model="item.client.name2"
          :error-messages="validation_errors.client.name2"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="課名"
          :readonly="!$attrs.isCreate"
          v-model="item.client.name3"
          :error-messages="validation_errors.client.name3"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="名前"
          :readonly="!$attrs.isCreate"
          v-model="item.client.name4"
          :error-messages="validation_errors.client.name4"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="敬称"
          :readonly="!$attrs.isCreate"
          :items="$store.getters.nameTitles"
          item-text="name"
          item-value="id"
          v-model="item.client.name_title"
          :error-messages="validation_errors.client.name_title"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*郵便番号"
          :readonly="!$attrs.isCreate"
          prepend-inner-icon="mdi-magnify"
          v-model="item.client.zipcode"
          @change="searchAddress"
          :error-messages="validation_errors.client.zipcode"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="*都道府県"
          :readonly="!$attrs.isCreate"
          :items=$store.getters.prefectures
          item-text="name"
          item-value="id"
          v-model="item.client.prefecture"
          :error-messages="validation_errors.client.prefecture"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="*住所1"
          :readonly="!$attrs.isCreate"
          v-model="item.client.address1"
          :error-messages="validation_errors.client.address1"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="住所2"
          :readonly="!$attrs.isCreate"
          v-model="item.client.address2"
          :error-messages="validation_errors.client.address2"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="電話番号"
          :readonly="!$attrs.isCreate"
          v-model="item.client.tel"
          :error-messages="validation_errors.client.tel"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="FAX"
          :readonly="!$attrs.isCreate"
          v-model="item.client.fax"
          :error-messages="validation_errors.client.fax"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="備考"
          :readonly="!$attrs.isCreate"
          v-model="item.client.note"
          :error-messages="validation_errors.client.note"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
        <v-subheader>購読設定</v-subheader>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
        sm="6"
      >
        <v-switch
          label="入金がなくても発送"
          v-model="item.shipping_without_payment"
          :error-messages="validation_errors.not_renew"
        >
        </v-switch>
      </v-col>
      <v-col
        cols="12"
        md="4"
        sm="6"
      >
        <v-switch
          label="契約終了時に更新しない"
          v-model="item.not_renew"
          :error-messages="validation_errors.not_renew"
        >
        </v-switch>
      </v-col>
      <v-col
        cols="12"
        md="4"
        sm="6"
      >
        <v-switch
          label="顧客情報と別の送付先を登録"
          v-model="item.delivery_to_others"
          :error-messages="validation_errors.deliver_to_others"
        >
        </v-switch>
      </v-col>
    </v-row>
    <v-row v-if="!$attrs.isCreate">
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-select
          label="ステータス"
          :items="$store.getters.subscriptionStatus"
          item-text="name"
          item-value="id"
          v-model="item.status_id"
          :error-messages="validation_errors.status_id"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="購読中止日"
              readonly
              v-on="on"
              v-model="item.stop_date"
              :error-messages="validation_errors.stop_date"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            v-model="item.stop_date"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        cols="12"
        md="5"
        sm="6"
      >
        <v-text-field
          label="送付先情報"
          v-model="item.delivery_note"
          :error-messages="validation_errors.delivery_note"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
        <v-subheader>購読情報</v-subheader>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*購読コード"
          v-model="item.cd"
          :error-messages="validation_errors.cd"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-select
          label="*商品カテゴリ"
          :items="$store.getters.productCategories"
          item-text="name"
          item-value="id"
          v-model="item.productcategory_id"
          :error-messages="validation_errors.productcategory_id"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-select
          label="*商品"
          :items="products"
          item-text="name"
          item-value="id"
          v-model="item.product_id"
          :error-messages="validation_errors.product_id"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-select
          label="*商品明細"
          :items="productdetails"
          item-text="name"
          item-value="id"
          v-model="item.productdetail_id"
          :error-messages="validation_errors.productdetail_id"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="*請求方法"
          :items=$store.getters.billingMethods
          item-text="name"
          item-value="id"
          v-model="item.billingmethod"
          :error-messages="validation_errors.billingmethod"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="*申込日"
              readonly
              v-on="on"
              v-model="item.application_date"
              :error-messages="validation_errors.application_date"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            v-model="item.application_date"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="*購読開始日"
              readonly
              v-on="on"
              v-model="item.startdate"
              :error-messages="validation_errors.startdate"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            v-model="item.startdate"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
        v-if="!$attrs.isCreate"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="購読終了日"
              readonly
              v-on="on"
              v-model="item.enddate"
              :error-messages="validation_errors.enddate"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            v-model="item.enddate"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        cols="12"
        md="5"
        sm="6"
      >
        <v-text-field
          label="備考"
          v-model="item.note"
          :error-messages="validation_errors.note"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="item.delivery_to_others">
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="合計個数"
          v-model="item.amount"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="合計正価(自動計算)"
          readonly
          v-model="computed_item.sum_list_price"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="*契約金額"
          v-model="item.price"
          :error-messages="validation_errors.price"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="合計送料"
          v-model="item.delivery_price"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*個数"
          v-model.number="item.amount"
          :error-messages="validation_errors.amount"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="*発送方法"
          :items=$store.getters.shippingMethods
          item-text="name"
          item-value="id"
          v-model="item.shippingmethod"
          :error-messages="validation_errors.shippingmethod"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="正価"
          readonly
          v-model="computed_item.list_price"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*契約金額"
          v-model="item.price"
          :error-messages="validation_errors.price"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*送料"
          v-model="item.delivery_price"
          :error-messages="validation_errors.delivery_price"
        ></v-text-field>
      </v-col>
    </v-row>
    <template v-if="item.delivery_to_others">
    <v-row>
      <v-col>
        <v-divider></v-divider>
        <v-subheader>送付先</v-subheader>
      </v-col>
    </v-row>
    <template>
    <v-row v-if="validation_errors.non_field_errors">
      <v-col>
        <span class="error--text text-caption" v-for="error in validation_errors.non_field_errors" :key="error">*{{ error }}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-dialog v-model="dialog" persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
            >
              送付先を追加する
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">送付先</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <client-search
                      :is-delivery-address="true"
                      :has-set="deliveryaddress_haset"
                      @setClient="setDeliveryAddress($event)"
                    >
                    </client-search>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    sm="6"
                  >
                  <span class="subtitle-1 red--text" v-if="deliveryitem.is_stopped">※この送付先は停止されています。</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-text-field
                      label="*送付先コード"
                      :readonly="!$attrs.isCreate && deliveryitem.id"
                      v-model="deliveryitem.deliveryaddress.cd"
                      :error-messages="deliveryitem.errors.deliveryaddress.cd"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-text-field
                      label="検索用カナ"
                      :readonly="!$attrs.isCreate && deliveryitem.id"
                      v-model="deliveryitem.deliveryaddress.search_kana"
                      :error-messages="deliveryitem.errors.deliveryaddress.search_kana"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-text-field
                      label="*会社名または個人名"
                      :readonly="!$attrs.isCreate && deliveryitem.id"
                      v-model="deliveryitem.deliveryaddress.name1"
                      :error-messages="deliveryitem.errors.deliveryaddress.name1"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-text-field
                      label="部署名"
                      :readonly="!$attrs.isCreate && deliveryitem.id"
                      v-model="deliveryitem.deliveryaddress.name2"
                      :error-messages="deliveryitem.errors.deliveryaddress.name2"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-text-field
                      label="課名"
                      :readonly="!$attrs.isCreate && deliveryitem.id"
                      v-model="deliveryitem.deliveryaddress.name3"
                      :error-messages="deliveryitem.errors.deliveryaddress.name3"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-text-field
                      label="名前"
                      :readonly="!$attrs.isCreate && deliveryitem.id"
                      v-model="deliveryitem.deliveryaddress.name4"
                      :error-messages="deliveryitem.errors.deliveryaddress.name4"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-select
                      label="敬称"
                      :readonly="!$attrs.isCreate && deliveryitem.id"
                      :items="$store.getters.nameTitles"
                      item-text="name"
                      item-value="id"
                      v-model="deliveryitem.deliveryaddress.name_title"
                      :error-messages="deliveryitem.errors.deliveryaddress.name_title"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-text-field
                      label="*郵便番号"
                      :readonly="!$attrs.isCreate && deliveryitem.id"
                      prepend-inner-icon="mdi-magnify"
                      v-model="deliveryitem.deliveryaddress.zipcode"
                      @change="searchDeliveryAddress"
                      :error-messages="deliveryitem.errors.deliveryaddress.zipcode"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-select
                      label="*都道府県"
                      :readonly="!$attrs.isCreate && deliveryitem.id"
                      :items=$store.getters.prefectures
                      item-text="name"
                      item-value="id"
                      v-model="deliveryitem.deliveryaddress.prefecture"
                      :error-messages="deliveryitem.errors.deliveryaddress.prefectures"
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    sm="6"
                  >
                    <v-text-field
                      label="*住所1"
                      :readonly="!$attrs.isCreate && deliveryitem.id"
                      v-model="deliveryitem.deliveryaddress.address1"
                      :error-messages="deliveryitem.errors.deliveryaddress.address1"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    sm="6"
                  >
                    <v-text-field
                      label="住所2"
                      :readonly="!$attrs.isCreate && deliveryitem.id"
                      v-model="deliveryitem.deliveryaddress.address2"
                      :error-messages="deliveryitem.errors.deliveryaddress.address2"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    sm="6"
                  >
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    sm="6"
                  >
                    <v-text-field
                      label="電話番号"
                      :readonly="!$attrs.isCreate && deliveryitem.id"
                      v-model="deliveryitem.deliveryaddress.tel"
                      :error-messages="deliveryitem.errors.deliveryaddress.tel"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    sm="6"
                  >
                    <v-text-field
                      label="FAX"
                      :readonly="!$attrs.isCreate && deliveryitem.id"
                      v-model="deliveryitem.deliveryaddress.fax"
                      :error-messages="deliveryitem.errors.deliveryaddress.fax"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    sm="6"
                  >
                    <v-text-field
                      label="備考"
                      :readonly="!$attrs.isCreate && deliveryitem.id"
                      v-model="deliveryitem.deliveryaddress.note"
                      :error-messages="deliveryitem.errors.deliveryaddress.note"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-select
                      label="*発送方法"
                      :items=$store.getters.shippingMethods
                      item-text="name"
                      item-value="id"
                      v-model="deliveryitem.shippingmethod"
                      :error-messages="deliveryitem.errors.shippingmethod"
                    >
                    </v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-text-field
                      label="*個数"
                      v-model="deliveryitem.amount"
                      :error-messages="deliveryitem.errors.amount"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-text-field
                      label="*送料"
                      v-model="deliveryitem.delivery_price"
                      :error-messages="deliveryitem.errors.delivery_price"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    @click="saveDeliveryItem"
                    color="primary">一時保存</v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    @click="cancelDeliveryItem"
                    color="default">キャンセル</v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    @click="deleteDeliveryItem"
                    class="red white--text" 
                    v-if="deliveryitem.counter || deliveryitem.id"
                    >削除</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    </template>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="item.subscriptiondeliveries"
          :items-per-page="50"
          :footer-props="footer_props"
          disable-sort
          disable-filtering
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
        >
        <template v-slot:item.action="{ item }">
          <v-btn
            v-if="item.has_error"
            small
            color="pink lighten-2"
            class="white--text"
            @click="editDeliveryItem(item)"
          >
            編集
          </v-btn>
          <v-btn
            v-else
            small
            color="default"
            @click="editDeliveryItem(item)"
          >
            編集
          </v-btn>
        </template>
        </v-data-table>
      </v-col>
    </v-row>
    </template>
    <v-row>
      <v-col
        cols="12"
        md="4"
        sm="8"
      >
        <v-text-field
          label="最終更新者"
          v-model="item.updated_by"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="最終更新日"
          v-model="item.updated_at"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="!item.is_deleted">
      <v-col
        cols="12"
        md="3"
        sm="3"
      ><v-btn class="red white--text" @click="save">保存する</v-btn></v-col>
      <v-col
        cols="12"
        md="3"
        sm="3"
        v-if="!$attrs.isCreate">
        <v-btn class="red white--text" @click="confirmCreateInvoice">請求処理を実行する</v-btn>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="3"
        v-if="!$attrs.isCreate">
        <v-btn class="red white--text" @click="selectBucknumber">配送データを作成する</v-btn>
        <v-dialog v-model="invoice_dialog" persistent>
          <v-card>
            <v-card-title>
              請求処理
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          label="*請求日"
                          readonly
                          v-on="on"
                          v-model="invoice_date_of_issue"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="ja"
                        no-title
                        @input="fromDateMenu = false"
                        v-model="invoice_date_of_issue"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          label="*契約開始日"
                          readonly
                          v-on="on"
                          v-model="invoice_target_date"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="ja"
                        no-title
                        @input="fromDateMenu = false"
                        v-model="invoice_target_date"
                      ></v-date-picker>
                    </v-menu>
                    契約開始日は、初期値として契約終了日の翌日が入力されています
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    @click="createInvoice"
                    class="white--text red"
                    >作成する</v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    @click="invoice_dialog = false"
                    color="default">キャンセル</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="shipping_dialog" persistent>
          <v-card>
            <v-card-title>
              配送データ作成
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          label="*発送日"
                          readonly
                          v-on="on"
                          v-model="shipping_delivery_date"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="ja"
                        no-title
                        @input="fromDateMenu = false"
                        v-model="shipping_delivery_date"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-data-table
                      :headers="backnumber_headers"
                      :items-per-page="8"
                      :items="backnumbers"
                      :footer-props="footer_props"
                      disable-sort
                      disable-filtering
                      locale="ja-jp"
                      loading-text="読込中"
                      no-data-text="データがありません。"
                    >
                    <template v-slot:item.action="{ item }">
                      <v-btn
                        small
                        class="red white--text"
                        @click="createShipping(item)"
                      >
                       この製品の配送データを作成する 
                      </v-btn>
                    </template>
                    </v-data-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    @click="shipping_dialog = false"
                    color="default">キャンセル</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ClientSearch from '@/components/ClientSearch'
import AddressSearch from '@/plugins/AddressSearch'

export default {
  components: {
    'client-search': ClientSearch,
  },
  data() {
    return {
      title: '',
      item: {
        'client': {'prefecture': null, 'industrycode': null, 'address1': ''},
        'subscriptiondeliveries': [],
      },
      validation_errors: {
        'client': {},
        'subscriptiondeliveries': [],
      },
      input_address: false,

      headers: [
        {text: "送付先コード", value: "deliveryaddress.cd"},
        {text: "送付先名称", value: "deliveryaddress.name_combined"},
        {text: "住所", value: "deliveryaddress.address_combined"},
        {text: "電話番号", value: "deliveryaddress.tel"},
        {text: "個数", value: "amount"},
        {text: "送料", value: "delivery_price"},
        {text: "操作", value: "action"},
      ],
      dialog: false,
      deliveryitemDefaultErrors: {
        deliveryaddress: {},
      },
      deliveryitemDefault: {
        deliveryaddress: {
          prefecture: null,
          industrycode: null,
          address1: '',
        },
        errors: {
          deliveryaddress: {},
        },
        has_error: false,
      },
      deliveryitem: {
        deliveryaddress: {
          prefecture: null,
          industrycode: null,
          address1: '',
        },
      },
      deliveryitem_counter: 1,
      products: [],
      productdetails: [],
      footer_props: {
      },
      client_haset: false,
      deliveryaddress_haset: false,

      invoice_dialog: false,
      invoice_date_of_issue: null,
      invoice_target_date: null,

      shipping_dialog: false,
      shipping_delivery_date: null,
      backnumbers: [],
      backnumber_headers: [
        {text: "名称", value: "name"},
        {text: "発売日", value: "release_date"},
        {text: "操作", value: "action"},
      ],
    }
  },
  created() {
    if (this.$attrs.isCreate) {
      this.title = "購読情報登録"
      if (this.$route.params.quotation_id) {
        this.getQuotation();
      }
    } else {
      this.title = "購読情報編集"
      this.getItem();
    }
    this.clearDeliveryitem();
  },
  computed: {
    computed_item() {
      let list_price = null;
      let unit_list_price = null;
      if (this.item.productdetail_id) {
        unit_list_price = this.productdetails.filter(x => x.id == this.item.productdetail_id)[0].price;
      }
      if (this.item.amount) {
        list_price = unit_list_price * this.item.amount;
      }
      let sum_amount = null;
      let sum_list_price = null;
      let sum_delivery_price = null;
      if (this.item.delivery_to_others) {
        //sum_amount = 0;
        //this.item.subscriptiondeliveries.forEach(element => {sum_amount = sum_amount + parseInt(element.amount);});
        sum_amount = this.item.amount;
        if (unit_list_price) {
          sum_list_price = unit_list_price * sum_amount;
        }
        //sum_delivery_price = 0;
        //this.item.subscriptiondeliveries.forEach(element => {sum_delivery_price = sum_delivery_price + parseInt(element.delivery_price);});
        sum_delivery_price = this.item.delivery_price;
      } else {
        // SUMにはどちらにしても値を入れておく
        sum_amount = this.item.amount;
        sum_list_price = list_price;
        sum_delivery_price = this.item.delivery_price;
      }
      return {
        list_price: list_price,
        sum_amount: sum_amount,
        sum_list_price: sum_list_price,
        sum_delivery_price: sum_delivery_price,
      }
    }
  },
  watch: {
    'item.productcategory_id': async function(val) {
      await this.loadProducts(val);
    },
    'item.product_id': async function(val) {
      await this.loadProductDetails(val);
    }
  },
  methods: {
    setClient(item) {
      this.item.client = item;
      if (item.id) {
        this.client_haset = true;
      } else {
        this.client_haset = false;
      }
    },
    async searchAddress() {
      const address_data = await AddressSearch.getAddressFromZipcode(this.item.client.zipcode);
      if (address_data) {
        this.item.client.prefecture = address_data.prefcode;
        this.item.client.address1 = address_data.address;
      }
    },
    async searchDeliveryAddress() {
      const address_data = await AddressSearch.getAddressFromZipcode(this.deliveryitem.deliveryaddress.zipcode);
      if (address_data) {
        this.deliveryitem.deliveryaddress.prefecture = address_data.prefcode;
        this.deliveryitem.deliveryaddress.address1 = address_data.address;
      }
    },
    clearDeliveryitem() {
      this.deliveryitemDefault.deliveryaddress = Object.assign({}, {'prefecture': null, 'address1': ''})
      this.deliveryitem = Object.assign({}, this.deliveryitemDefault)
    },
    setDeliveryAddress(item) {
      this.deliveryitem.deliveryaddress = item;
      if (item.id) {
        this.deliveryaddress_haset = true;
      } else {
        this.deliveryaddress_haset = false;
      }
    },
    async loadProducts(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/`,
            {
              params: {'productcategory': val},
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          )
          this.products = response.data.results;
        } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
            this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
          }
      } else {
        this.products = []
      }
    },
    async loadProductDetails(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/${val}/details/`,
            {
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          )
          this.productdetails = response.data;
        } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        }
      } else {
        this.productdetails = [];
      }
    },
    editDeliveryItem(item) {
      this.deliveryitem = item;
      this.dialog = true;
    },
    saveDeliveryItem() {
      // 本来ならサーバー側で処理したい表示用名称の処理をここで行う
      let name_combined = '';
      if (this.deliveryitem.deliveryaddress.name1) {
        name_combined = this.deliveryitem.deliveryaddress.name1;
      }
      if (this.deliveryitem.deliveryaddress.name2) {
        name_combined = `${name_combined} ${this.deliveryitem.deliveryaddress.name2}`;
      }
      if (this.deliveryitem.deliveryaddress.name3) {
        name_combined = `${name_combined} ${this.deliveryitem.deliveryaddress.name3}`;
      }
      if (this.deliveryitem.deliveryaddress.name4) {
        name_combined = `${name_combined} ${this.deliveryitem.deliveryaddress.name4}`;
      }
      this.deliveryitem.deliveryaddress.name_combined = name_combined;

      let address_combined = '';
      if (this.deliveryitem.deliveryaddress.prefecture) {
        address_combined = this.$store.getters.prefectures.filter(x => x.id == this.deliveryitem.deliveryaddress.prefecture)[0].name;
      }
      if (this.deliveryitem.deliveryaddress.address1) {
        address_combined = `${address_combined}${this.deliveryitem.deliveryaddress.address1}`;
      }
      if (this.deliveryitem.deliveryaddress.address2) {
        address_combined = `${address_combined}${this.deliveryitem.deliveryaddress.address3}`;
      }
      this.deliveryitem.deliveryaddress.address_combined = address_combined;

      if (! this.deliveryitem.id && ! this.deliveryitem.counter) {
        this.deliveryitem.counter = this.deliveryitem_counter;
        this.deliveryitem_counter++;
        this.item.subscriptiondeliveries.push(this.deliveryitem);
      } else {
        let target_idx = null;
        this.item.subscriptiondeliveries.forEach((element, idx) => {
          if ( (this.deliveryitem.id && element.id == this.deliveryitem.id)
            || (this.deliveryitem.counter && element.counter == this.deliveryitem.counter)) {
              target_idx = idx
            }
          }
        );

        if (target_idx !== null) {
          this.item.subscriptiondeliveries[target_idx] = this.deliveryitem;
        }
      }
      this.clearDeliveryitem();
      this.deliveryaddress_haset = false;
      this.dialog = false;
    },
    deleteDeliveryItem() {
      let target_idx = null;
      this.item.subscriptiondeliveries.forEach((element, idx) => {
        if ( (this.deliveryitem.id && element.id == this.deliveryitem.id)
          || (this.deliveryitem.counter && element.counter == this.deliveryitem.counter)) {
            target_idx = idx
          }
        }
      );

      if (target_idx !== null) {
        this.item.subscriptiondeliveries.splice(target_idx, 1);
      }
      this.clearDeliveryitem();
      this.deliveryaddress_haset = false;
      this.dialog = false;

    },
    cancelDeliveryItem() {
      this.clearDeliveryitem();
      this.deliveryaddress_haset = false;
      this.dialog = false;
    },
    async getItem() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/subscriptions/${this.$route.params.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        const data = response.data;
        data.productcategory_id = data.productdetail.product.productcategory.id;
        await this.loadProducts(data.productdetail.product.productcategory.id)
        data.product_id = data.productdetail.product.id;
        await this.loadProductDetails(data.productdetail.product.id)
        this.item = data;
        this.item.subscriptiondeliveries.forEach((elem) => {
          elem.errors = Object.assign({}, this.deliveryitemDefaultErrors);
        });
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
      }
    },
    async getQuotation() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/quotations/${this.$route.params.quotation_id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        const data = response.data;
        data.productcategory_id = data.productdetail.product.productcategory.id;
        await this.loadProducts(data.productdetail.product.productcategory.id)
        data.product_id = data.productdetail.product.id;
        await this.loadProductDetails(data.productdetail.product.id)
        this.item = data;
        this.item.subscriptiondeliveries = [];
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
      }
    },
    async save() {
      if (this.$attrs.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    async create() {
      let response = null;
      try {
        response = await this.$axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/subscriptions/`,
          {...this.item, ...this.computed_item},
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.validation_errors = {
          'client': {},
          'subscriptiondeliveries': [],
        };
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "登録できませんでした", type: "error"});
        this.validation_errors = error.response.data;
        if (!this.validation_errors.client) {
          this.validation_errors.client = {};
        }
        if (!this.validation_errors.subscriptiondeliveries) {
          this.validation_errors.subscriptiondeliveries = [];
        } else {
          this.bindSubscriptiondeliveryError(this.validation_errors.subscriptiondeliveries);
        }
        return;
      }
      if (this.$route.params.quotation_id) {
        try {
          await this.$axios.post(
            `${process.env.VUE_APP_API_URL_BASE}/api/sub/quotations/${this.$route.params.quotation_id}/subscription/`,
            {subscription_id: response.data.id},
            {
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          )
        } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
          this.$store.dispatch('setSnackbar', {message: "見積もりと紐付けできませんでした", type: "error"});
        }
      }
      this.$store.dispatch('setSnackbar', {message: "登録されました", type: "success"});
      this.$router.push({'name': 'EditSubscription', 'params': {id: response.data.id}});
    },
    async update() {
      try {
        console.log(this.item.stop_date)
        await this.$axios.put(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/subscriptions/${this.$route.params.id}/`,
          {...this.item, ...this.computed_item},
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.$store.dispatch('setSnackbar', {message: "保存されました", type: "success"});
        this.validation_errors = {
          'client': {},
          'subscriptiondeliveries': [],
        };
        await this.getItem();
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "更新できませんでした", type: "error"});
        this.validation_errors = error.response.data;
        if (!this.validation_errors.client) {
          this.validation_errors.client = {};
        }
        if (!this.validation_errors.subscriptiondeliveries) {
          this.validation_errors.subscriptiondeliveries = [];
        } else {
          this.bindSubscriptiondeliveryError(this.validation_errors.subscriptiondeliveries);
        }
      }
    },
    bindSubscriptiondeliveryError(errors) {
      this.item.subscriptiondeliveries.forEach((element, idx) => {
        const error = errors[idx];
        if (error && Object.keys(error).length) {
          element.has_error = true;
          element.errors = Object.assign(Object.assign({}, this.deliveryitemDefaultErrors), error);
        } else {
          element.has_error = false;
          element.errors = Object.assign({}, this.deliveryitemDefaultErrors);
        }
        console.log(element.has_error)
      });
    },
    async confirmCreateInvoice() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/subscriptions/${this.$route.params.id}/next_invoice_date/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.invoice_target_date = response.data.target_date;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得できませんでした", type: "error"});
      }
      this.invoice_dialog = true;
    },
    async createInvoice() {
      try {
        await this.$axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/subscriptions/${this.$route.params.id}/invoice/`,
          {date_of_issue: this.invoice_date_of_issue, target_date: this.invoice_target_date},
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.$store.dispatch('setSnackbar', {message: "作成されました", type: "success"});
        this.invoice_dialog = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "作成できませんでした", type: "error"});
      }
    },
    async getBacknumbers() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/subscriptions/${this.$route.params.id}/backnumbers/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.backnumbers = response.data;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得できませんでした", type: "error"});
      }
    },
    selectBucknumber() {
      this.getBacknumbers();
      this.shipping_dialog = true;
    },
    async createShipping(item) {
      try {
        await this.$axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/subscriptions/${this.$route.params.id}/shippings/`,
          {delivery_date: this.shipping_delivery_date, 'deliveryitemdetail_id': item.id},
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.$store.dispatch('setSnackbar', {message: "作成されました", type: "success"});
        this.shipping_dialog = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "作成できませんでした", type: "error"});
      }
    },
  }
}
</script>